import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared footer with links to the two policy pages.
 * `active` highlights the current page: "refund" | "privacy" | undefined.
 */
const PolicyFooter = ({ active }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="policy-footer">
      <div className="policy-footer-links">
        <Link
          to="/kebijakan-pembatalan-refund"
          className={`policy-footer-link${active === "refund" ? " active" : ""}`}
        >
          Kebijakan Pembatalan &amp; Refund
        </Link>
        <Link
          to="/kebijakan-privasi"
          className={`policy-footer-link${active === "privacy" ? " active" : ""}`}
        >
          Kebijakan Privasi &amp; Perlindungan Data
        </Link>
      </div>
      <p className="policy-footer-copy">
        Copyright © {year}. Prasetiya Mulya Executive Learning Institute. All
        Rights Reserved
      </p>
    </footer>
  );
};

export default PolicyFooter;
